module.exports = require("fs");;